import { render, staticRenderFns } from "./ShopTournamentSchedule.vue?vue&type=template&id=4984d04e"
import script from "./ShopTournamentSchedule.vue?vue&type=script&lang=js"
export * from "./ShopTournamentSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports